<template>
  <div class="p-t-xs-20 p-b-xs-20" v-if="pagination?.pages && pagination.totalCount">
    <ul class="pager pager--center">
      <PaginationItem v-for="page in pagination?.pages"
                      :key="page.number"
                      :page="page"
                      @pageChanged="$emit('pageChanged')"
      />
    </ul>
  </div>
</template>
<script>
import {useStore} from 'vuex'
import {computed} from 'vue'
import PaginationItem from './PaginationItem'
export default {
  name: "Pagination",
  components:{
    PaginationItem,
  },
  setup(){
    const store = useStore()
    const pagination = computed( () => store.getters.data?.pagination);

    return{
      pagination
    }
  }
}
</script>